import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="gym-floor relative w-full text-white" data-id="element-54" data-mp="1zyh2w7skw2x2">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-55" data-mp="1uy2vmryswx03" />
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-56" data-mp="1v0fmjumjehpa">
        <h2 className="font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-57" data-mp="1pyq9yajo1vz3">
          Stop planning on Sundays. <span className="text-amber" data-id="element-58" data-mp="1l1gd49ty6i18">Start walking in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-59" data-mp="1g8napslyblsb">
          Six volumes, 52 weekly classes and five bonuses. A full year of rec
          gymnastics — floor, bars, beam and vault, every skill at three levels,
          printable and ready to teach.
        </p>

        <div className="mt-7" data-id="element-60" data-mp="128m6q4ae3y8m">
          <Countdown size="sm" tone="dark" data-id="element-61" data-mp="128vx3szck7eu" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber bg-ink-deep/60 px-5 py-4 text-left" data-id="element-62" data-mp="xaaytz3nnxt1">
          <div data-id="element-63" data-mp="40r2fgnrky46">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-amber" data-id="element-64" data-mp="40herzq6z31n">Complete package</span>
            <span className="text-[15px] font-semibold text-white" data-id="element-65" data-mp="3liab53jsxck2">Rec Gymnastics Class-Ready — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-66" data-mp="3qe7rvayz8kxd">
            <span className="text-[15px] text-white/60 line-through" data-id="element-67" data-mp="i1k02a9d49bi">$97</span>
            <span className="font-display text-4xl font-extrabold leading-none text-white" data-id="element-68" data-mp="n051gd0coz1j">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-69" data-mp="81jcgc4gn71i">
          <CtaButton data-id="element-70" data-mp="d1fh8dkzf2i4">Yes, I want to walk in ready — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-71" data-mp="d3ii5snoag1m">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-72" data-mp="2xt7rxr9irbng">
              <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-73" data-mp="1497bwdbdhugl" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}